import axios from "@util/axios";
import _ from "lodash";
import { trackPromise } from "react-promise-tracker";
import { sha512 } from "js-sha512";
import { transformFiltersForRequest } from "@util/Scripts";
import projectConfig from "@projectConfig";
import { isActivePublicUser } from "../../util/Scripts";
const { hostCloud, hostB2 } = projectConfig.api;

const token = localStorage.getItem("token");

export const checkSession = () => {
   const url = `${hostCloud}/legacy/check-session`;
   return axios({
      method: "get",
      url: url,
      headers: {
         Accept: "*/*",
         "Content-Type": "application/json",
      },
   });
};

export const getToken = async () => {
   const url = `${hostCloud}/legacy/request`;
   return axios({
      method: "post",
      url: url,
      headers: {
         Accept: "*/*",
         "Content-Type": "application/json",
      },
      data: {
         endpoint: `/utils/method/getSingleUseToken`,
         httpMethod: "GET",
         isAuthenticated: true,
      },
   });
};

export const getStorePolicy = async (guestToken, selectedRegulation, domainKey) => {
   // key should be equal domainKey
   let key = domainKey;
   // Remove this if when support sets proper site names -> domainKey_selectedRegulation
   if (domainKey === "hoppy" || domainKey === "fotoevent") {
      key = "awards";
   }
   const HEADER = '{"typ":"signature"}';
   const PAYLOAD = `{"timestamp":${Date.now()}}`;
   const signature = sha512
      .hmac(process.env.REACT_APP_LIST_DATA, `${HEADER}.${PAYLOAD}`)
      .toLowerCase();
   const legacyToken = `${btoa(HEADER)}.${btoa(PAYLOAD)}.${btoa(signature)}`;
   const data = {
      endpoint: `/request/model/Pages/params/%7B%22%60key%60%22%3A%22${key}_${selectedRegulation}%22%2C%20%22lang%22%3A%22pl%22%7D`,
      httpMethod: "GET",
      isAuthenticated: true,
      apiController: "/index.php/restApi",
      host: hostB2,
      legacyAuth: guestToken,
   };

   return await trackPromise(
      axios({
         method: "post",
         url: `${hostCloud}/private/legacy/request/direct`,
         headers: {
            Accept: "*/*",
            "Content-Type": "application/json",
            "Cross-Origin": "https://bp2.cloud",
            Authorization: legacyToken,
         },
         data: data,
      }),
   );
};

export const getListAccess = async (listId) => {
   const url = `${hostCloud}/legacy/request`;
   return axios({
      method: "post",
      url: url,
      headers: {
         Accept: "*/*",
         "Content-Type": "application/json",
      },
      data: {
         endpoint: `/lists/method/getAccesses`,
         httpMethod: "GET",
         isAuthenticated: true,
         parameters: `/{\"listId\":${listId}}`,
      },
   });
};

export const createGuestTokenWithSignature = async () => {
   const HEADER = '{"typ":"signature"}';
   const PAYLOAD = `{"timestamp":${Date.now()}}`;

   const signature = sha512
      .hmac(process.env.REACT_APP_LIST_DATA, `${HEADER}.${PAYLOAD}`)
      .toLowerCase();

   const legacyToken = `${btoa(HEADER)}.${btoa(PAYLOAD)}.${btoa(signature)}`;

   const data = {
      endpoint: `/createGuestToken`,
      httpMethod: "GET",
      isAuthenticated: false,
      apiController: "/index.php/restApi",
      host: hostB2,
   };
   return await trackPromise(
      axios({
         method: "post",
         url: `${hostCloud}/private/legacy/request/direct`,
         headers: {
            Accept: "*/*",
            "Content-Type": "application/json",
            "Cross-Origin": "https://bp2.cloud",
            Authorization: legacyToken,
         },
         data: data,
      }),
   );
};

export const setUserLocation = async (pos, id) => {
   const url = `${hostCloud}/legacy/request`;
   const posArr = JSON.parse("[" + pos + "]");

   return await axios({
      method: "post",
      url: url,
      headers: {
         Accept: "*/*",
         "Content-Type": "application/json",
      },
      data: {
         endpoint: `/request/model/User/params/{"id": ${id}}`,
         httpMethod: "PUT",
         isAuthenticated: true,
         body: JSON.stringify({
            last_location_latitude: posArr[0],
            last_location_longitude: posArr[1],
         }),
      },
   });
};

export const addSubformData = async (id, body) => {
   const url = `${hostCloud}/legacy/request`;

   return await axios({
      method: "post",
      url: url,
      headers: {
         Accept: "*/*",
         "Content-Type": "application/json",
      },
      data: {
         endpoint: `/forms-v2/method/getSubformData`,
         httpMethod: "PUT",
         parameters: `/{"subformId": ${id}}`,
         isAuthenticated: true,
         body: JSON.stringify(body),
      },
   });
};

export const editDevForm = async (body) => {
   const url = `${hostCloud}/legacy/request`;

   return await axios({
      method: "post",
      url: url,
      headers: {
         Accept: "*/*",
         "Content-Type": "application/json",
      },
      data: {
         endpoint: `/forms-v2/method/save-form-builder`,
         httpMethod: "POST",
         isAuthenticated: true,
         body: JSON.stringify(body),
      },
   });
};

export const deleteInstanceAttachment = async (instanceId, fileId) => {
   const url = `${hostCloud}/legacy/request`;
   return await axios({
      method: "post",
      url: url,
      headers: {
         Accept: "*/*",
         "Content-Type": "application/json",
      },
      data: {
         endpoint: `/workflow/method/deleteFiles`,
         parameters: `/{"instanceId": ${instanceId}}`,
         httpMethod: "DELETE",
         isAuthenticated: true,
         body: JSON.stringify([fileId]),
      },
   });
};

export const changeWorkflowImage = async (instanceId, name, type, base64Img, confId) => {
   const url = `${hostCloud}/legacy/request`;

   const parameters = {};

   if (instanceId) {
      parameters.instId = instanceId;
   }

   if (confId) {
      parameters.confId = confId;
   }

   return await axios({
      method: "post",
      url: url,
      headers: {
         Accept: "*/*",
         "Content-Type": "application/json",
      },
      data: {
         endpoint: `/workflow/method/changeDefaultLogo`,
         parameters: `/${JSON.stringify(parameters)}`,
         httpMethod: "POST",
         isAuthenticated: true,
         body: JSON.stringify({
            name: name,
            type: type,
            imgB64Data: base64Img,
         }),
      },
   });
};

export const getInstanceAttachments = async (id) => {
   const url = `${hostCloud}/legacy/request`;
   return await axios({
      method: "post",
      url: url,
      headers: {
         Accept: "*/*",
         "Content-Type": "application/json",
      },
      data: {
         endpoint: `/workflow/method/getFiles`,
         parameters: `/{"instanceId": ${id}}`,
         httpMethod: "GET",
         isAuthenticated: true,
      },
   }).then((res) => {
      return res;
   });
};

export const getList = async (listId, page, itemsPerPage, profile, sortValues) => {
   const url = `${hostCloud}/legacy/request`;

   const params = {
      listId,
      pagination: {
         page,
         itemsPerPage,
      },
   };

   if (profile) {
      params.profile = profile;
   }

   if (sortValues?.columnAttribute && sortValues?.direction) {
      params.sort = {
         field: sortValues.columnAttribute,
         direction: sortValues.direction,
      };
   }

   return await trackPromise(
      axios({
         method: "post",
         url: url,
         headers: {
            Accept: "*/*",
            "Content-Type": "application/json",
         },
         data: {
            endpoint: isActivePublicUser() ? "/lists/method/getPublicList" : "/lists",
            httpMethod: "GET",
            isAuthenticated: true,
            parameters: JSON.stringify(params),
         },
      }).then((res) => {
         return res;
      }),
   );
};

export const getFilteredList = async (
   listId,
   page,
   itemsPerPage,
   filterAttr,
   filterValue,
   profileId,
   sortValues,
) => {
   const url = `${hostCloud}/legacy/request`;
   const modelName = filterAttr.split(".")[0];
   const objectName = filterAttr.split(".")[1];
   var params;
   if (filterAttr.includes("search") && !filterValue && !profileId) {
      params = `/{\"listId\":${listId},\"pagination\":{\"page\":${page},\"itemsPerPage\":${itemsPerPage}},${filterAttr}}`;
   } else if (filterValue && !profileId) {
      params = `/{\"listId\":${listId},\"pagination\":{\"page\":${page},\"itemsPerPage\":${itemsPerPage}},\"search\":{\"${modelName}\":{\"${objectName}\":\"${filterValue}\"}}}`;
   } else if (profileId) {
      params = `/{\"listId\":${listId},\"pagination\":{\"page\":${page},\"itemsPerPage\":${itemsPerPage}},\"search\":{\"${modelName}\":{\"${objectName}\":\"${filterValue}\"}},\"profile\":\"${profileId}\"}`;
   } else {
      params = `/{\"listId\":${listId},\"pagination\":{\"page\":${page},\"itemsPerPage\":${itemsPerPage}}}`;
   }

   if (sortValues?.columnAttribute && sortValues?.direction) {
      // Because backend can't do normal column attribute nad they give us Model.Attribute we need to split it and take only attribute
      params =
         params.slice(0, -1) +
         `,"sort":{"field":"${sortValues.columnAttribute.split(".")[1]}","direction":"${
            sortValues.direction
         }"}}`;
   }

   return await trackPromise(
      axios({
         method: "post",
         url: url,
         headers: {
            Accept: "*/*",
            "Content-Type": "application/json",
         },
         data: {
            endpoint: isActivePublicUser() ? "/lists/method/getPublicList" : "/lists",
            httpMethod: "GET",
            isAuthenticated: true,
            parameters: encodeURI(params),
         },
      }).then((res) => {
         return res;
      }),
   );
};

// filterValues is an object in format specified below:
// {
//		attribute1: value1,
//    attribute2: value2,
//    ...
// }
// Single attribute consist of model name and object name
export const getProperlyFilteredList = async (listId, page, itemsPerPage, filterValues) => {
   const url = `${hostCloud}/legacy/request`;

   const params = {
      listId,
      pagination: {
         page,
         itemsPerPage,
      },
      filter: transformFiltersForRequest(filterValues),
   };

   return await axios({
      method: "post",
      url: url,
      headers: {
         Accept: "*/*",
         "Content-Type": "application/json",
      },
      data: {
         endpoint: isActivePublicUser() ? "/lists/method/getPublicList" : "/lists",
         httpMethod: "GET",
         isAuthenticated: true,
         //eslint-disable-next-line
         parameters: JSON.stringify(params),
      },
   });
};

export const getListV2 = async (listId, page, itemsPerPage, filterValues, profile, sortValues) => {
   const url = `${hostCloud}/legacy/request`;
   const { filters, strictFilters } = transformFiltersForRequest(filterValues);
   const params = {
      listId,
      pagination: {
         page,
         itemsPerPage,
      },
      filter: filters,
      strictFilters: strictFilters,
      profile: profile,
   };
   if (sortValues?.columnAttribute && sortValues?.direction) {
      params.sort = {
         field: sortValues.columnAttribute,
         direction: sortValues.direction,
      };
   }

   return await axios({
      method: "post",
      url: url,
      headers: {
         Accept: "*/*",
         "Content-Type": "application/json",
      },
      data: {
         endpoint: "/lists",
         httpMethod: "GET",
         isAuthenticated: true,
         //eslint-disable-next-line
         parameters: JSON.stringify(params),
      },
   });
};

export const getListStructure = async (listId) => {
   const url = `${hostCloud}/legacy/request`;
   const params = {
      listId,
   };

   return await axios({
      method: "post",
      url: url,
      headers: {
         Accept: "*/*",
         "Content-Type": "application/json",
      },
      data: {
         endpoint: "/lists/method/getStructure",
         httpMethod: "GET",
         isAuthenticated: true,
         //eslint-disable-next-line
         parameters: JSON.stringify(params),
      },
   });
};

export const getListProfiles = async (listId) => {
   const url = `${hostCloud}/legacy/request`;
   return await axios({
      method: "post",
      url: url,
      headers: {
         Accept: "*/*",
         "Content-Type": "application/json",
      },
      data: {
         endpoint: "/lists/method/getProfiles",
         httpMethod: "GET",
         isAuthenticated: true,
         //eslint-disable-next-line
         parameters: JSON.stringify({ listId }),
      },
   }).then((res) => {
      return res;
   });
};

export const deleteListRows = async (body, listId, locationKey) => {
   const url = `${hostCloud}/legacy/request`;
   return await axios({
      method: "post",
      url: url,
      headers: {
         Accept: "*/*",
         "Content-Type": "application/json",
      },
      data: {
         endpoint: "/lists/method/deleteRows",
         httpMethod: "DELETE",
         isAuthenticated: true,
         parameters: JSON.stringify({
            listId: listId,
            locationKey: locationKey,
         }),
         body: JSON.stringify(body),
      },
   });
};

export const saveRecord = async (model, params, id) => {
   const url = `${hostCloud}/legacy/request`;
   return await axios({
      method: "post",
      url: url,
      headers: {
         Accept: "*/*",
         "Content-Type": "application/json",
      },
      data: {
         //eslint-disable-next-line
         endpoint: "/request/model/" + model + "/params" + `/{\"id\": ${id}}`,
         httpMethod: "PUT",
         isAuthenticated: true,
         body: JSON.stringify(params),
      },
   }).then((res) => {
      return res;
   });
};

export const getPdf = async (id, name, gdtoken) => {
   axios({
      url: `https://cors-anywhere.herokuapp.com/https://drive.google.com/u/0/uc?id=${id}&export=download`,
      method: "GET",
      responseType: "blob",
      headers: {
         Authorization: "Bearer " + gdtoken,
      },
   }).then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", name);
      document.body.appendChild(link);
      link.click();
   });
};

export const privateRegistration = async (
   values,
   code,
   groupNumber,
   registrationTemplate,
   formId,
) => {
   const HEADER = '{"typ":"signature"}';
   const PAYLOAD = `{"timestamp":${Date.now()}}`;

   const signature = sha512
      .hmac(process.env.REACT_APP_LIST_DATA, `${HEADER}.${PAYLOAD}`)
      .toLowerCase();

   const signature2 = sha512
      .hmac(
         "8Rf99LBKW0EsVc50wgv0D24BgTggzaw7pDCTyUic3wMvrvvJyryLPlwifXudAXWW",
         `${HEADER}.${PAYLOAD}`,
      )
      .toLocaleLowerCase();

   const legacyToken = `${btoa(HEADER)}.${btoa(PAYLOAD)}.${btoa(signature)}`;
   const legacyAuth = `${btoa(HEADER)}.${btoa(PAYLOAD)}.${btoa(signature2)}`;

   const body = {
      UserRegistrationRequest_organization_unm18u: groupNumber,
      UserRegistrationRequest_referencing_user_id_tz7bvk: "10586",
      UserRegistrationRequest_registration_mode_nec2hi: "API",
      UserRegistrationRequest_registration_status_1ma0gk: "CREATED",
      UserRegistrationRequest_template_id_emxy07: registrationTemplate,
      email: values.email,
      imie: values.firstName,
      kod_code: code,
      login: projectConfig.registration?.mailAsLogin ? values.email : values.login,
      nazwisko: values.lastName,
      password_clear: values.password,
      UIF_ID: formId,
      easyForm: true,
   };

   const checksum = sha512
      .hmac(process.env.REACT_APP_LIST_DATA, JSON.stringify(body))
      .toLowerCase();

   const data = {
      endpoint: `/forms/method/saveForm`,
      httpMethod: "POST",
      isAuthenticated: true,
      apiController: "/index.php/restApi",
      host: hostB2,
      legacyAuth: legacyAuth,
      body: JSON.stringify(body),
   };

   return await trackPromise(
      axios({
         method: "post",
         url: `${hostCloud}/private/legacy/request/direct`,
         headers: {
            Accept: "*/*",
            "Content-Type": "application/json",
            "Cross-Origin": `https://bp2.cloud`,
            Authorization: legacyToken,
            Checksum: checksum,
         },
         data: data,
      }),
   );
};

export const twoStepRegistration = async (formBody) => {
   const HEADER = '{"typ":"signature"}';
   // this userId needs to be hardCoded ~ Java
   const PAYLOAD = `{"data":{"userId":${10005}},"timestamp":${Date.now()}}`;

   const signature = sha512
      .hmac(process.env.REACT_APP_LIST_DATA, `${HEADER}.${PAYLOAD}`)
      .toLowerCase();

   const signature2 = sha512
      .hmac(
         "8Rf99LBKW0EsVc50wgv0D24BgTggzaw7pDCTyUic3wMvrvvJyryLPlwifXudAXWW",
         `${HEADER}.${PAYLOAD}`,
      )
      .toLocaleLowerCase();

   const legacyToken = `${btoa(HEADER)}.${btoa(PAYLOAD)}.${btoa(signature)}`;
   const legacyAuth = `${btoa(HEADER)}.${btoa(PAYLOAD)}.${btoa(signature2)}`;

   const data = {
      endpoint: `/forms-v2`,
      httpMethod: "POST",
      isAuthenticated: true,
      apiController: "/index.php/restApi",
      host: hostB2,
      legacyAuth: legacyAuth,
      body: JSON.stringify(formBody),
   };

   return await trackPromise(
      axios({
         method: "post",
         url: `${hostCloud}/private/legacy/request/direct`,
         headers: {
            Accept: "*/*",
            "Content-Type": "application/json",
            "Cross-Origin": `https://bp2.cloud`,
            Authorization: legacyToken,
         },
         data: data,
      }),
   );
};

export const setTaskDate = async (date, messageId) => {
   const url = `${hostCloud}/email/message/schedule`;
   return axios({
      method: "PUT",
      url: url,
      headers: {
         Accept: "*/*",
         "Content-Type": "application/json",
      },
      data: {
         date: `${date}`,
         messageId: `${messageId}`,
      },
   });
};

export const getMessageStep = async (id, idType = "message") => {
   let parameters;
   if (idType === "message") {
      parameters = `/{"msgId":${id}, "withoutEmptyComments": true}`;
   }
   if (idType === "instance") {
      parameters = `/{"instId":${id}}`;
   }

   const url = `${hostCloud}/legacy/request`;
   return axios({
      method: "post",
      url: url,
      headers: {
         Accept: "*/*",
         "Content-Type": "application/json",
      },
      data: {
         endpoint: "/workflow/method/step",
         httpMethod: "GET",
         isAuthenticated: true,
         parameters: parameters,
      },
   }).then((res) => {
      // TODO - to remove when back fixes comments response. It should be always array
      if (res?.data?.step?.comments) {
         const comments = res?.data?.step?.comments;
         if (comments && Array.isArray(comments)) {
            res.data.step.comments = comments;
         } else if (comments && !Array.isArray(comments)) {
            const commentsArray = [];
            Object.keys(comments).map((key) => {
               commentsArray.push(comments[key]);
            });
            res.data.step.comments = commentsArray;
         }
      }
      return res;
   });
};

export const getColumnSum = async (listId, columnToSumTechnames, filters, profile) => {
   const url = `${hostCloud}/legacy/request`;
   const params = {
      listId,
      columnToSumTechnames,
      filter: transformFiltersForRequest(filters),
      profile,
   };

   return axios({
      method: "post",
      url: url,
      headers: {
         Accept: "*/*",
         "Content-Type": "application/json",
      },
      data: {
         endpoint: `/lists/method/getSumColumns`,
         httpMethod: "GET",
         isAuthenticated: true,
         parameters: JSON.stringify(params),
      },
   });
};

export const startProcessInstance = async (
   configId,
   dataModelName,
   dataId,
   routerLocationUniqueKey,
) => {
   const url = `${hostCloud}/legacy/request`;
   return axios({
      method: "post",
      url: url,
      headers: {
         Accept: "*/*",
         "Content-Type": "application/json",
      },
      data: {
         endpoint: `/workflow/method/start`,
         httpMethod: "POST",
         isAuthenticated: true,
         parameters: `/{\"configId\":${configId}, \"withIdempotency\": false}`, //eslint-disable-line
         body:
            dataModelName !== undefined && dataModelName !== null
               ? `{\"dataModelName\":\"${dataModelName}\",\"dataId\":\"${dataId}\"}` //eslint-disable-line
               : null,
      },
   });
};
export const runListAction = async (actionId, recordId, formKey) => {
   const params = {};
   if (formKey) {
      params.actionKey = formKey;
   } else {
      params.actionId = actionId;
      params.recordId = recordId;
   }
   const url = `${hostCloud}/legacy/request`;
   return axios({
      method: "post",
      url: url,
      headers: {
         Accept: "*/*",
         "Content-Type": "application/json",
      },
      data: {
         endpoint: `/lists/method/actions`,
         httpMethod: "POST",
         isAuthenticated: true,
         parameters: JSON.stringify(params),
      },
   });
};

export const registerFromInvite = async (values, code, token) => {
   const HEADER = '{"typ":"signature"}';
   const PAYLOAD = `{"timestamp":${Date.now()}}`;
   const signature = sha512
      .hmac(process.env.REACT_APP_LIST_DATA, `${HEADER}.${PAYLOAD}`)
      .toLowerCase();
   const legacyToken = `${btoa(HEADER)}.${btoa(PAYLOAD)}.${btoa(signature)}`;
   const params = { code: code };
   const data = {
      endpoint: `/user/method/updateAndProcessByCode`,
      httpMethod: "POST",
      isAuthenticated: true,
      apiController: "/index.php/restApi",
      host: hostB2,
      legacyAuth: token,
      parameters: JSON.stringify(params),
      body: JSON.stringify({
         user: {
            f_name: values.firstName,
            l_name: values.lastName,
            email: values.email,
            login: projectConfig.registration?.mailAsLogin ? values.email : values.login,
            password: values.password,
         },
      }),
   };

   return await trackPromise(
      axios({
         method: "post",
         url: `${hostCloud}/private/legacy/request/direct`,
         headers: {
            Accept: "*/*",
            "Content-Type": "application/json",
            "Cross-Origin": "https://bp2.cloud",
            Authorization: legacyToken,
         },
         data: data,
      }),
   );
};

export const remindPassword = async (email, title, templateId, sendAsText) => {
   const HEADER = '{"typ":"signature"}';
   const PAYLOAD = `{"timestamp":${Date.now()}}`;

   const signature = sha512
      .hmac(process.env.REACT_APP_LIST_DATA, `${HEADER}.${PAYLOAD}`)
      .toLowerCase();

   const legacyToken = `${btoa(HEADER)}.${btoa(PAYLOAD)}.${btoa(signature)}`;

   const params = {
      title,
      to: email,
      sendAs: sendAsText,
      templateId,
      variables: {
         "{reset_password_link}": `${window.location.origin}/changePassword`,
      },
   };

   const data = {
      endpoint: `/utils/method/remindPassword`,
      httpMethod: "POST",
      isAuthenticated: false,
      apiController: "/index.php/restApi",
      host: hostB2,
      body: JSON.stringify(params),
   };

   return axios({
      method: "POST",
      url: `${hostCloud}/private/legacy/request/direct`,
      headers: {
         Accept: "*/*",
         "Content-Type": "application/json",
         "Cross-Origin": "https://bp2.cloud",
         Authorization: legacyToken,
      },
      data: data,
   });
};

export const verifyRecaptcha = async (captchaValue) => {
   return axios({
      method: "post",
      url: `${hostCloud}/verifyReCaptcha`,
      headers: {
         Accept: "*/*",
         "Content-Type": "application/json",
      },
      data: captchaValue,
   });
};

export const addPlatformDomain = async (name) => {
   const url = `${hostCloud}/platform-domain`;
   return await trackPromise(
      axios({
         method: "post",
         url: url,
         headers: {
            Accept: "*/*",
            "Content-Type": "application/json",
            Authorization: token,
         },
         data: {
            name: name,
         },
      }),
   );
};

export const deletePlatformDomain = async (id) => {
   const url = `${hostCloud}/platform-domain?platformDomainId=${id}`;
   return await trackPromise(
      axios({
         method: "delete",
         url: url,
         headers: {
            Accept: "*/*",
            "Content-Type": "application/json",
            Authorization: token,
         },
      }),
   );
};

export const getAllPlatformDomain = async () => {
   const url = `${hostCloud}/platform-domain/all`;
   return await trackPromise(
      axios({
         method: "get",
         url: url,
         headers: {
            Accept: "*/*",
            "Content-Type": "application/json",
            Authorization: token,
         },
      }),
   );
};

export const addPublicUser = async (id) => {
   const url = `${hostCloud}/public-user`;
   return await trackPromise(
      axios({
         method: "post",
         url: url,
         headers: {
            Accept: "*/*",
            "Content-Type": "application/json",
            Authorization: token,
         },
         data: {
            platformDomainId: id,
         },
      }),
   );
};

export const editDomainInfo = async (domainId, mainPageUrl, basketUrl) => {
   const url = `${hostCloud}/platform-domain`;
   return await trackPromise(
      axios({
         method: "put",
         url: url,
         headers: {
            Accept: "*/*",
            "Content-Type": "application/json",
            Authorization: token,
         },
         data: {
            id: domainId,
            basketUrl,
            mainPageUrl,
         },
      }),
   );
};

export const deletePublicUser = async (id) => {
   const url = `${hostCloud}/public-user?publicUserId=${id}`;
   return await trackPromise(
      axios({
         method: "delete",
         url: url,
         headers: {
            Accept: "*/*",
            "Content-Type": "application/json",
            Authorization: token,
         },
      }),
   );
};

export const getAllPublicUsers = async () => {
   const url = `${hostCloud}/public-user/all`;
   return await trackPromise(
      axios({
         method: "get",
         url: url,
         headers: {
            Accept: "*/*",
            "Content-Type": "application/json",
         },
      }),
   );
};

export const addBoardToPublicUser = async (userId, boardId) => {
   const url = `${hostCloud}/public-user/board?publicUserId=${userId}&boardId=${boardId}`;
   return await trackPromise(
      axios({
         method: "post",
         url: url,
         headers: {
            Accept: "*/*",
            "Content-Type": "application/json",
            Authorization: token,
         },
      }),
   );
};

export const removeBoardFromPublicUser = async (userId, boardId) => {
   const url = `${hostCloud}/public-user/board?publicUserId=${userId}&boardId=${boardId}`;
   return await trackPromise(
      axios({
         method: "delete",
         url: url,
         headers: {
            Accept: "*/*",
            "Content-Type": "application/json",
            Authorization: token,
         },
      }),
   );
};

export const editBoardFromPublicUser = async (userId, boardId, order) => {
   const url = `${hostCloud}/public-user/board?publicUserId=${userId}&boardId=${boardId}&order=${order}`;
   return await trackPromise(
      axios({
         method: "put",
         url: url,
         headers: {
            Accept: "*/*",
            "Content-Type": "application/json",
            Authorization: token,
         },
      }),
   );
};

export const getPublicUser = async (publicDomain, scope) => {
   const url = `${hostCloud}/public/public-user/${scope}/${publicDomain}`;
   return await trackPromise(
      axios({
         method: "get",
         url: url,
         headers: {
            Accept: "*/*",
            "Content-Type": "application/json",
         },
      }),
   );
};

export const checkPassword = async (password) => {
   const HEADER = '{"typ":"signature"}';
   const PAYLOAD = `{"timestamp":${Date.now()}}`;

   const signature = sha512
      .hmac(process.env.REACT_APP_LIST_DATA, `${HEADER}.${PAYLOAD}`)
      .toLowerCase();

   const legacyToken = `${btoa(HEADER)}.${btoa(PAYLOAD)}.${btoa(signature)}`;

   const data = {
      endpoint: `/restApi/utils/method/checkPassword`,
      httpMethod: "POST",
      isAuthenticated: true,
      body: JSON.stringify({ password }),
      apiController: "/index.php/restApi",
      host: hostB2,
   };
   return await trackPromise(
      axios({
         method: "post",
         url: `${hostCloud}/private/legacy/request/direct`,
         headers: {
            Accept: "*/*",
            "Content-Type": "application/json",
            "Cross-Origin": "https://bp2.cloud",
            Authorization: legacyToken,
         },
         data: data,
      }),
   );
};

export const resetPasswordByAuthorizedUser = async (email, oldPassword, passHash) => {
   const params = JSON.stringify({ email: btoa(email) });

   const data = {
      endpoint: `/user/method/resetPassword`,
      httpMethod: "POST",
      isAuthenticated: true,
      body: JSON.stringify({ oldPassword: oldPassword, newPassword: passHash }),
      parameters: params,
   };

   return await trackPromise(
      axios({
         method: "post",
         url: `${hostCloud}/legacy/request`,
         headers: {
            Accept: "*/*",
            "Content-Type": "application/json",
         },
         data: data,
      }),
   );
};

export const resetPasswordByUnauthorizedUser = async (email, newPassword, key) => {
   const HEADER = '{"typ":"signature"}';
   const PAYLOAD = `{"timestamp":${Date.now()}}`;

   const signature = sha512
      .hmac(process.env.REACT_APP_LIST_DATA, `${HEADER}.${PAYLOAD}`)
      .toLowerCase();

   const legacyToken = `${btoa(HEADER)}.${btoa(PAYLOAD)}.${btoa(signature)}`;

   const params = JSON.stringify({ email: btoa(email), key: key });

   const data = {
      endpoint: `/user/method/resetPassword`,
      httpMethod: "POST",
      isAuthenticated: true,
      parameters: params,
      apiController: "/index.php/restApi",
      host: hostB2,
      legacyAuth: legacyToken,
      body: JSON.stringify({ newPassword: newPassword }),
   };

   return await trackPromise(
      axios({
         method: "post",
         url: `${hostCloud}/private/legacy/request/direct`,
         headers: {
            Accept: "*/*",
            "Content-Type": "application/json",
            "Cross-Origin": `https://bp2.cloud`,
            Authorization: legacyToken,
         },
         data: data,
      }),
   );
};

export const restoreLogin = async (nip, phoneNumber) => {
   const data = {
      endpoint: `/user/method/restoreLogin`,
      httpMethod: "POST",
      isAuthenticated: true,
      body: JSON.stringify({ nip, phone: phoneNumber }),
   };

   return await trackPromise(
      axios({
         method: "post",
         url: `${hostCloud}/legacy/request`,
         headers: {
            Accept: "*/*",
            "Content-Type": "application/json",
         },
         data: data,
      }),
   );
};

export const logoutUser = async () => {
   const url = `${hostCloud}/legacy/logout`;

   return axios({
      method: "post",
      url: url,
      headers: {
         Accept: "application/json",
         "Content-Type": "application/json",
      },
      data: {
         httpMethod: "POST",
      },
   });
};

export const getListExcel = async (listId, page, itemsPerPage, profile) => {
   const url = `${hostCloud}/legacy/request`;
   const params = profile
      ? `/{\"listId\":${listId},\"pagination\":{\"page\":${page},\"itemsPerPage\":${itemsPerPage}},\"profile\":\"${profile}\"}` //eslint-disable-line
      : `/{\"listId\":${listId},\"pagination\":{\"page\":${page},\"itemsPerPage\":${itemsPerPage}}}`; //eslint-disable-line
   return await trackPromise(
      axios({
         method: "post",
         url: url,
         headers: {
            Accept: "*/*",
            "Content-Type": "application/json",
         },
         data: {
            endpoint: isActivePublicUser() ? "/lists/method/getPublicList" : "/lists",
            headers: {
               Accept: "*/*",
               "Content-Type": "application/vnd.ms-excel",
            },
            httpMethod: "GET",
            isAuthenticated: true,
            //eslint-disable-next-line
            parameters: params,
         },
      }).then((res) => {
         return res;
      }),
   );
};

// this api use mailgun (gmail banned our domain)
export const sendEmail = (emailAdress, value, sender, title) => {
   const url = `${hostCloud}/legacy/request`;

   const body = {
      title: title,
      to: emailAdress,
      body: value,
      sendAs: sender,
   };

   return axios({
      method: "post",
      url: url,
      headers: {
         Accept: "*/*",
         "Content-Type": "application/json",
      },
      data: {
         endpoint: `/mail`,
         httpMethod: "POST",
         isAuthenticated: true,
         body: JSON.stringify(body),
      },
   });
};

export const getRodoBannerInfo = async () => {
   return axios({
      method: "get",
      url: `${hostCloud}/rodo`,
      headers: {
         Accept: "*/*",
         "Content-Type": "application/json",
      },
   });
};

export const executeWorkflowStep = (actionKey, formData, comment, recipientId, stepId) => {
   const url = `${hostCloud}/legacy/request`;

   const body = {
      actionKey: actionKey,
      formData: formData,
      detailedResponse: true,
      actionData: {
         comment: comment,
         recipientId: recipientId,
         stepId: stepId,
      },
   };

   return axios({
      method: "post",
      url: url,
      headers: {
         Accept: "*/*",
         "Content-Type": "application/json",
      },
      data: {
         endpoint: `/workflow-v2/method/action`,
         httpMethod: "POST",
         isAuthenticated: true,
         body: JSON.stringify(body),
      },
   }).then((res) => {
      let response = res;
      if (res.data.action.step) {
         response.data.action = res.data.action.step;
      }
      return response;
   });
};
